<app-progress></app-progress>
<div row>
  <div column>
    <div [class]="classForBoard" board>
      <table [class]="classForState">
        @for (row of ps.brd.rows; let y = $index; track y) {
          <tr>
            @for (_ of row; let x = $index; track x) {
              <td (click)="clickCell($event, x, y)" [class]="classForCell(x, y)">
                <div container>
                  <div content>{{ cellContent(x, y) }}</div>
                  <div info>{{ cellInfo(x, y) }}</div>
                </div>
              </td>
            }
          </tr>
        }
      </table>
      @if (ps.boardString != null) {
        <div solution>{{ ps.boardString?.toUpperCase() }}</div>
      }
    </div>
    <div>
      @for (part of ps.srv.board.parts; track $index) {
        <button (click)="clickPart($event, part.key)" [class]="classForPart(part.key)" mat-button part>
          {{ part.key }}
        </button>
      }
    </div>
  </div>
  <div column>
    @if (ps.solutionsFor(ps.brd?.date).length > 0) {
      <button (click)="clickTest($event, ps.brd?.date, true)" [disabled]="!ps.isValid || ps.isWorking" mat-button>
        {{ msgSolution }}
      </button>
    }
    @if (ps.mayChangeSolutions) {
      @if (ps.solverParts.length > 0) {
        <button (click)="clickTest($event, ps.solverParts.join(''))" [disabled]="!ps.isValid || ps.isWorking || ps.solverParts.length < ps.srv.board.parts.length" mat-button>
          {{ ps.solverParts.join('').toUpperCase() }}
        </button>
      }
      @if (!hasStar && hasSolutions) {
        <button (click)="clickSolve($event, 'single')" [disabled]="!ps.isValid || ps.isWorking" mat-button>
          {{ msgSolve }}
        </button>
      }
      @if (!hasStar) {
        <button (click)="clickSolve($event, 'day')" [disabled]="!ps.isValid || ps.isWorking" mat-button>
          Tageslösungen ermitteln
        </button>
      }
      <button (click)="clickSolve($event, 'oneperday')" [disabled]="!ps.isValid || ps.isWorking" mat-button>Eine Lösung pro Tag ermitteln</button>
      <button (click)="clickSolve($event, 'all')" [disabled]="!ps.isValid || ps.isWorking" mat-button>Alle Lösungen ermitteln</button>
      <button (click)="clickClear($event)" [disabled]="!ps.isValid || ps.isWorking" mat-button>
        <mat-icon>delete</mat-icon>
        Lösungen für den Tag löschen
      </button>
    }
    <div limits>
      <div>Max: {{ maxSolutions }}</div>
      <div>Min: {{ minSolutions }}</div>
    </div>
    <div switches>
      <mat-button-toggle-group [(ngModel)]="ps.showColors">
        @for (option of colorList; track $index) {
          <mat-button-toggle [value]="option.value">
            {{ option.label }}
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
      <mat-slide-toggle (change)="toggleImmediate($event)" [checked]="ps.showImmediate">Sofort anzeigen</mat-slide-toggle>
      <div>Orientierungsfilter</div>
      <mat-button-toggle-group (change)="onOrientChange($event)" [(ngModel)]="ps.filterOrientation" multiple>
        @for (option of orientList; track $index) {
          <mat-button-toggle [class]="classForOrient(option)" [value]="option.value">
            {{ option.label }}
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
      <mat-slide-toggle (change)="toggleAssetLoad($event)" [checked]="!ps.mayChangeSolutions">Vom Server laden</mat-slide-toggle>
      @if (!ps.mayChangeSolutions) {
        <div nochange>Die Lösungen wurden vom Server geladen und können nicht geändert werden.</div>
      }
    </div>
    <button (click)="ps.copySolutionToClipboard()" mat-button>
      Alle Lösungen in die Zwischenablage kopieren
    </button>
  </div>
</div>
